import { UserEntity } from "../entity/UserEntity";
import { User } from "../gateway/User/User";

export class GetUsersByIdsUsecase {
    constructor() {
        this.UserGateway = new User();
    }

    async execute({ ids, configs = {} } = {}) {
        const payload = this.sanitizeInput({ ids, configs });
        if (!payload.ids.length) return null;
        const response = await this.UserGateway.getByIdsConfigs(
            payload.ids,
            payload.configs
        );
        const list = response?.list ?? response;
        if (!Array.isArray(list)) return null;
        return list.map((user) => UserEntity.restoreFromCloud(user));
    }

    sanitizeInput({ ids, configs = {} } = {}) {
        if (!Array.isArray(ids)) return { ids: [], configs };
        const sanitizedIds = ids.map((id) => String(id).trim()).filter(Boolean);
        return { ids: Array.from(new Set(sanitizedIds)), configs };
    }
}
